import GroupsFeature from "../features/Groups";

export default function Groups() {
  return <GroupsFeature />;
}

